export default [
  { name: 'surfer-activity-surfer-activity', path: 'surfer-activity/surfer-activity', component: () => import('../milkbox/pages/SurferActivity.vue') }
]
